import { render, staticRenderFns } from "./SitemapList.vue?vue&type=template&id=7ad92f37&"
import script from "./SitemapList.vue?vue&type=script&lang=js&"
export * from "./SitemapList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports